:host { display: block; }

.price-breakdown {
  padding: 20px;
  background: #fff;
}

.price-breakdown ul {
  padding: 0;
  margin: 0;  
  max-width: 40em;
  overflow-x: hidden;
  list-style: none;
}

.price-breakdown ul li {
  padding-bottom: 8px;
}

.price-breakdown ul li:before {
  float: left;
  width: 0;
  white-space: nowrap;
  content:
". . . . . . . . . . . . . . . . . . . . "
". . . . . . . . . . . . . . . . . . . . "
". . . . . . . . . . . . . . . . . . . . "
". . . . . . . . . . . . . . . . . . . . "
}

.price-line-label {
  padding-right: 0.33em;
  background: white
}

.price-line-value {
  float: right;
  padding-left: 0.33em;
  background: white
}

.total .price-line-label,
.total .price-line-value { font-weight: 600; }

.discount .price-line-label,
.discount .price-line-value { color: red; }

.credit .price-line-label,
.credit .price-line-value { color: red; }

.price-line.level2 {
  margin-left: 20px;
  font-size: 0.9em;
  color: #666;
}